export default __webpack_public_path__ + "locales/sk/Errors.json?hash=6a2c2b09e59ee5dca5719187325880a4";